import { render, staticRenderFns } from "./LibraryBrands.vue?vue&type=template&id=7013502f&scoped=true"
import script from "./LibraryBrands.vue?vue&type=script&lang=js"
export * from "./LibraryBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7013502f",
  null
  
)

export default component.exports